import {
    booleanAttribute,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    computed,
    DestroyRef,
    inject,
    input,
    ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DialogService } from '@pixelgenau/ngx-dialog';
import { switchMap } from 'rxjs';
import { M000C010ImageComponent } from '../../000-primitives/m000-c010-image/m000-c010-image.component';
import { VehicleGalleryOverlayDialogTag } from './m030-c160-vehicle-gallery-overlay/m030-c160-vehicle-gallery-overlay.dialog';

@Component({
    selector: 'ui-m030-c160-vehicle-gallery',
    standalone: true,
    templateUrl: './m030-c160-vehicle-gallery.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [M000C010ImageComponent],
})
export class M030C160VehicleGalleryComponent {
    images = input.required<string[]>();
    isFirstView = input.required({ transform: booleanAttribute });

    protected readonly dialogService = inject(DialogService);
    readonly cdr = inject(ChangeDetectorRef);
    destroyRef = inject(DestroyRef);

    async openVehicleGalleryOverlay(index: number) {
        this.dialogService
            .openDialog(VehicleGalleryOverlayDialogTag, {
                images: this.images(),
                activeIndex: index,
            })
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                switchMap((result) => result.close$),
            )
            .subscribe(() => {
                this.cdr.detectChanges();
            });
    }

    desktopImages = computed(() => {
        return this.images().slice(1, 5);
    });
}
